import React, { useState } from "react";
import { Drawer } from "antd";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { useTranslation, withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { ThemeToggle } from "../../common/ThemeToggle";
import {
  Actions,
  DesktopNav,
  HeaderSection,
  LanguageSelect,
  LogoContainer,
  MenuButton,
  MobileActions,
  MobileNav,
  NavItem,
  PrimaryAction,
  SecondaryAction,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const currentLanguage = i18n.language.toLowerCase();
  const language = currentLanguage.startsWith("es") ? "es" : currentLanguage.startsWith("sw") ? "sw" : "en";

  const navigation = [
    { to: "/product", label: t("Product") },
    { to: "/features", label: t("Features") },
    { to: "/pricing", label: t("Pricing") },
    { to: "/security", label: t("Security") },
    { to: "/contact", label: t("Contact") },
  ];

  return (
    <HeaderSection>
      <Container>
        <div className="header-inner">
          <LogoContainer to="/" aria-label="LendDisk home">
            <img src="/img/logo.png" alt="LendDisk" />
          </LogoContainer>

          <DesktopNav aria-label="Primary navigation">
            {navigation.map((item) => (
              <NavItem key={item.to} to={item.to} activeClassName="active">
                {item.label}
              </NavItem>
            ))}
          </DesktopNav>

          <Actions>
            <LanguageSelect value={language} onChange={(event) => i18n.changeLanguage(event.target.value)} aria-label={t("Switch language")}>
              <option value="en">EN</option>
              <option value="es">ES</option>
              <option value="sw">SW</option>
            </LanguageSelect>
            <ThemeToggle />
            <SecondaryAction href="https://app.lenddisk.com/#/login">
              {t("Sign In")}
            </SecondaryAction>
            <PrimaryAction href="https://app.lenddisk.com/#/register">
              {t("Start Free Trial")}
            </PrimaryAction>
          </Actions>

          <MenuButton
            type="button"
            aria-label={t("Open menu")}
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <MenuOutlined />
          </MenuButton>
        </div>
      </Container>

      <Drawer
        placement="right"
        closable={false}
        open={open}
        onClose={close}
        title={
          <div className="mobile-drawer-title">
            <img src="/img/logo.png" alt="LendDisk" />
            <button type="button" aria-label={t("Close menu")} onClick={close}>
              <CloseOutlined />
            </button>
          </div>
        }
      >
        <MobileNav aria-label="Mobile navigation">
          {navigation.map((item) => (
            <NavItem key={item.to} to={item.to} activeClassName="active" onClick={close}>
              {item.label}
            </NavItem>
          ))}
        </MobileNav>
        <MobileActions>
          <LanguageSelect value={language} onChange={(event) => i18n.changeLanguage(event.target.value)} aria-label={t("Switch language")}>
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="sw">Kiswahili</option>
          </LanguageSelect>
          <ThemeToggle />
          <SecondaryAction href="https://app.lenddisk.com/#/login">
            {t("Sign In")}
          </SecondaryAction>
          <PrimaryAction href="https://app.lenddisk.com/#/register">
            {t("Start Free Trial")}
          </PrimaryAction>
        </MobileActions>
      </Drawer>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
